import { createStoreGlobal } from '@/store';
import { IProductListData, OrderEntity } from '@/types';
import { IBrandData } from '@/types/brand';
import { action, computed } from 'mobx';

const storeGlobal = createStoreGlobal();

export const useStoreGlobal = () => {
  const setProductListData = action((data: IProductListData) => {
    storeGlobal.data = data;
  });

  const setBranddata = action((data: IBrandData) => {
    storeGlobal.brandData = data;
    if (data.title) {
      document.title = data.title;
    }
    if (data.theme) {
      storeGlobal.colorPrimary = data.theme;
    }
    if (data.icon) {
      const url = `${import.meta.env.VITE_OSS}/editor/image/${data.icon}`;
      let link = document.querySelector('#favicon') as
        | HTMLLinkElement
        | undefined;
      if (link) {
        link.href = url;
      } else {
        const head = document.getElementsByTagName('head')[0];
        link = document.createElement('link');
        link.type = 'image/png';
        link.rel = 'icon';
        link.href = url;
        head.appendChild(link);
      }
    }
  });

  const setCurrentProductId = action((id: string) => {
    const find = storeGlobal.data?.list?.find((item) => {
      return item.id + '' === id;
    });
    if (find) {
      storeGlobal.currentProductId = id;
    }
  });

  const currentProduct = computed(() => {
    return storeGlobal.data?.list?.find(
      (item) => item.id + '' === storeGlobal.currentProductId,
    );
  });

  const reset = action(() => {
    storeGlobal.currentProductId = '';
    // storeGlobal.editMode = false;
    storeGlobal.order = undefined;
    storeGlobal.currentComponentId = '';
    storeGlobal.hicustomSelectedCompId = '';
    storeGlobal.hicustomDesignAll = false;
    storeGlobal.tool = '';
  });

  const setEditMode = action((value: boolean) => {
    storeGlobal.editMode = value;
  });

  const setOrder = action((order?: OrderEntity) => {
    storeGlobal.order = order;
  });

  const setCurrentComponentId = action((id: string) => {
    storeGlobal.currentComponentId = id;
  });

  const setHicustomSelectedCompId = action((id: string) => {
    storeGlobal.hicustomSelectedCompId = id;
  });

  const setHicustomDesignAll = action((value: boolean) => {
    storeGlobal.hicustomDesignAll = value;
  });

  const setCurrentTool = action((tool: string) => {
    storeGlobal.tool = tool;
  });

  const setIframeMode = action((value: boolean) => {
    storeGlobal.iframeMode = value;
  });

  const updateProductImg = action((id: string, newUrl: string) => {
    const item = storeGlobal.data?.list?.find((x) => x.id === id);
    if (item) {
      item.img = newUrl;
    }
  });

  return {
    store: storeGlobal,
    setProductListData,
    setBranddata,
    setCurrentProductId,
    currentProduct,
    reset,
    setEditMode,
    setOrder,
    setCurrentComponentId,
    setHicustomSelectedCompId,
    setHicustomDesignAll,
    setCurrentTool,
    setIframeMode,
    updateProductImg,
  };
};
